import axios from 'axios';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

import { axiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listCustomerCreditCards = (queryString) => {
  if (queryString) {
    return axios.get(
      `${getV1RootUrl()}/customer/${customerId()}/credit-card?${queryString}`,
      axiosHeader()
    );
  }
  return axios.get(
    `${getV1RootUrl()}/customer/${customerId()}/credit-card`,
    axiosHeader()
  );
};

export const getCustomerCreditCard = (customerCreditCardId) =>
  axios.get(
    `${getV1RootUrl()}/customer/${customerId()}/credit-card/${customerCreditCardId}`,
    axiosHeader()
  );

export const getCustomerCreditCardDefault = () =>
  axios.get(
    `${getV1RootUrl()}/customer/${customerId()}/credit-card/default`,
    axiosHeader()
  );

export const addCustomerCreditCard = (customerCreditCard) =>
  axios.post(
    `${getV1RootUrl()}/customer/${customerId()}/credit-card/`,
    customerCreditCard,
    axiosHeader()
  );

export const editCustomerCreditCard = (
  customerCreditCardId,
  customerCreditCard
) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId()}/credit-card/${customerCreditCardId}`,
    customerCreditCard,
    axiosHeader()
  );

export const deleteCustomerCreditCard = (customerCreditCardId) =>
  axios.delete(
    `${getV1RootUrl()}/customer/${customerId()}/credit-card/${customerCreditCardId}`,
    axiosHeader()
  );

const customerId = () => jwtDecode(Cookies.get('customerToken')).sub;
